import Login from './Login';

export default Login;



// WEBPACK FOOTER //
// ./src/views/Login/index.js